<template>

	<!-- Layout Header ( Navbar ) -->
	<a-layout-header>
		<div class="header-col header-brand">
			<img :src="$APPCFG.cfg_logo" alt="" style="height: 50px; cursor: pointer;" @click="$router.push('/index')">

			<!-- Trigger Button For Navigation Menu For Small Screens -->
			<a-button type="link" @click="collapseNav = collapseNav ? 0 : 1 " class="btn-menu-trigger">
				<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/></svg>
			</a-button>
			<!-- Trigger Button For Navigation Menu For Small Screens -->

		</div>
        <div class="header-col header-nav nav_list">
            <a-menu mode="horizontal" class="menu-large">
				<a-menu-item>
					<router-link to="/index" class="nav-link" @click="e => e.preventDefault()">
						<span>{{ $t('header_1') }}</span>
					</router-link>
				</a-menu-item>
				<a-menu-item>
					<router-link to="/calc_freight" class="nav-link" @click="e => e.preventDefault()">
						<span>{{ $t('header_2') }}</span>
					</router-link>
				</a-menu-item>
                <a-menu-item>
					<router-link to="/track" class="nav-link" @click="e => e.preventDefault()">
						<span>{{ $t('header_3') }}</span>
					</router-link>
				</a-menu-item>
                <a-menu-item>
					<router-link :to="$store.state.lang == 'en' ? '/p/129' : '/p/4'" class="nav-link" @click="e => e.preventDefault()">
						<span>{{ $t('header_4') }}</span>
					</router-link>
				</a-menu-item>
                <a-menu-item>
					<router-link :to="$store.state.lang == 'en' ? '/page/alist/8' : '/page/alist/5'" class="nav-link" @click="e => e.preventDefault()">
						<span>{{ $t('header_5') }}</span>
					</router-link>
				</a-menu-item>
                <a-menu-item>
					<router-link to="/contact" class="nav-link" @click="e => e.preventDefault()">
						<span>{{ $t('header_6') }}</span>
					</router-link>
				</a-menu-item>
			</a-menu>

            <div class="lang"  @mouseenter="showFlag=true" @mouseleave="showFlag=false">
                <div class="flag_box">
                    <div class="flag" @click="changeLang('en')"><img :src="$STATIC_URL + 'index/au_flag.png'" alt=""></div>
                    <div class="flag" v-if="showFlag" @click="changeLang('zh')">
                        <img :src="$STATIC_URL + 'index/china_flag.png'" alt="">
                    </div>
                </div>
                <a-icon type="down" style="font-size:12px;color:#000;"></a-icon>
            </div>
        </div>
		<div class="header-col header-nav" >


			<!-- Collapsible Navigation Menu For Small Screens -->
			<div class="menu-small">
				
				<!-- Collapsible Component For Navigation Menu For Small Screens -->
				<a-collapse v-model="collapseNav" accordion>
					<a-collapse-panel key="1">

						<!-- Navigation Menu For Small Screens -->
						<a-menu mode="vertical">
                            <a-menu-item>
                                <router-link to="/index" class="nav-link" @click="e => e.preventDefault()">
                                    <span>{{ $t('header_1') }}</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item>
                                <router-link to="/calc_freight" class="nav-link" @click="e => e.preventDefault()">
                                    <span>{{ $t('header_2') }}</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item>
                                <router-link to="/track" class="nav-link" @click="e => e.preventDefault()">
                                    <span>{{ $t('header_3') }}</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item>
                                <router-link :to="$store.state.lang == 'en' ? '/p/129' : '/p/4'" class="nav-link" @click="e => e.preventDefault()">
                                    <span>{{ $t('header_4') }}</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item>
                                <router-link :to="$store.state.lang == 'en' ? '/page/alist/8' : '/page/alist/5'" class="nav-link" @click="e => e.preventDefault()">
                                    <span>{{ $t('header_5') }}</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item>
                                <router-link to="/contact" class="nav-link" @click="e => e.preventDefault()">
                                    <span>{{ $t('header_6') }}</span>
                                </router-link>
                            </a-menu-item>
							<a-menu-item>
                                <router-link to="/login" class="nav-link" @click="e => e.preventDefault()">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path class="fill-muted" fill-rule="evenodd" clip-rule="evenodd" d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z" fill="#111827"/>
                                    </svg>
                                    <span>{{ $t('header_7') }}</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item>
                                <router-link to="/register" class="nav-link" @click="e => e.preventDefault()">
                                    <svg width="14px" height="14px" class="fill-muted" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <g class="fill-muted" id="Tables" transform="translate(-58.000000, -507.000000)" fill="#BFBFBF" fill-rule="nonzero">
                                                <g id="sidebar" transform="translate(33.000000, 43.000000)">
                                                    <g id="sign-up" transform="translate(16.000000, 455.000000)">
                                                        <g id="duplicate" transform="translate(9.000000, 9.000000)">
                                                            <path d="M4,6 C4,4.89543 4.89543,4 6,4 L12,4 C13.1046,4 14,4.89543 14,6 L14,12 C14,13.1046 13.1046,14 12,14 L6,14 C4.89543,14 4,13.1046 4,12 L4,6 Z" id="Path"></path>
                                                            <path d="M2,0 C0.89543,0 0,0.89543 0,2 L0,8 C0,9.1046 0.89543,10 2,10 L2,4 C2,2.8954305 2.8954305,2 4,2 L10,2 L10,2 C10,0.89543 9.1046,0 8,0 L2,0 Z" id="Path"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <span>{{ $t('header_8') }}</span>
                                </router-link>
                            </a-menu-item>
						</a-menu>
						<!-- / Navigation Menu For Small Screens -->

					</a-collapse-panel>
				</a-collapse>
				<!-- / Collapsible Component For Navigation Menu For Small Screens -->

			</div>
			<!-- / Collapsible Navigation Menu For Small Screens -->
		</div>

        <div class="header-col header-btn">
            <a-button type="link" shape="round" @click="onToUrl"><a-icon type="user" style="color: #0565a9; font-size: 20px;"></a-icon></a-button>
			<a-button type="primary" shape="round" @click="$router.push('/register')">{{ $t('header_9') }}</a-button>
		</div>
	</a-layout-header>
	<!-- / Layout Header ( Navbar ) -->

</template>

<script>

	export default ({
		data() {
			return {
				// Collapse navigation value.
				// Binded model property for "Collapsible Navigation Menu" collapsed status .
				collapseNav: 0,

                showFlag: false,
			}
		},
        created() {
            
        },
        methods: {
            onToUrl() {
                if(localStorage.getItem('mtoken')) {
                    this.$router.push('/user/info');
                }else {
                    this.$router.push('/login');
                }
            },
            changeLang(lang) {
                this.$store.commit('changeLang', lang);
            }
        }
	})

</script>

<style lang="scss" scoped>

	.nav-link svg {
		margin-right: 5px;
		vertical-align: middle;
	}
	.nav-link span {
		vertical-align: middle;
	}
	.ant-menu-submenu-popup {
		width: 100%;
	}

    .nav_list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1 !important;
        /deep/ .ant-menu-horizontal {
            text-align: center !important;
            .ant-menu-item {
                a {
                    padding: 6px 40px !important;
                    font-size: 16px;
                }
            }
        }
    }

    .lang {
        margin: 0;
        flex: none;
        display: flex;
        align-items: center;
        height: 64px;
        position: relative;
        z-index: 1;
        .flag_box {
            height: 28px;
            margin-right: 8px;
            .flag {
                padding: 2px;
                bordeR: 1px solid #ccc;
                border-radius: 2px;
                margin-bottom: 5px;
                background: #fff;
                cursor: pointer;
                a {
                    margin: 0px;
                    padding: 0px;
                    border: none;
                }
                img {
                    width: 32px;
                    display: block;
                }
            }
        }
    }
</style>